import { F, P } from "../../styles/palette";
import { PC, PBack, Bdg } from "../shared";
import useClinicalRecords from "../../hooks/useClinicalRecords";
import { ISL } from "../../data/islStages";

const VAS_COLOR = v => v <= 2 ? "#16a34a" : v <= 4 ? "#ca8a04" : v <= 6 ? "#ea580c" : "#dc2626";
const VAS_LABEL = v => v <= 2 ? "Leve" : v <= 4 ? "Moderado" : v <= 6 ? "Intenso" : "Severo";

export default function PHistory({ nav, patientId }) {
  const { records, loading } = useClinicalRecords(patientId);

  if (!patientId) {
    return (
      <div>
        <PBack nav={nav} />
        <PC>
          <p style={{ color: P.txM, fontSize: 14, textAlign: "center", padding: 16 }}>
            Su cuenta aún no está vinculada a un expediente médico. Consulte con su médico para vincular su cuenta.
          </p>
        </PC>
      </div>
    );
  }

  if (loading) {
    return (
      <div>
        <PBack nav={nav} />
        <p style={{ color: P.txM, fontSize: 13, textAlign: "center", padding: 20 }}>Cargando historial...</p>
      </div>
    );
  }

  return (
    <div>
      <PBack nav={nav} />
      <h2 style={{ fontSize: 24, color: P.tx, margin: "0 0 6px", fontFamily: "Libre Baskerville, Georgia, serif" }}>
        Mi Historial Clínico
      </h2>
      <p style={{ color: P.txM, fontSize: 14, margin: "0 0 22px" }}>
        Resumen de sus sesiones de tratamiento. Para más detalles, consulte con su médico.
      </p>

      {records.length === 0 ? (
        <PC>
          <p style={{ color: P.txM, fontSize: 14, textAlign: "center", padding: 16 }}>
            No hay evoluciones registradas aún. Luego de su primera sesión aparecerán aquí.
          </p>
        </PC>
      ) : (
        records.map((r, i) => {
          const fecha = r.fecha?.toDate
            ? r.fecha.toDate().toLocaleDateString("es-CO", { weekday: "short", year: "numeric", month: "long", day: "numeric" })
            : "—";
          const isl = r.objetivo?.estadioISL != null ? ISL[r.objetivo.estadioISL] : null;
          const vas = r.objetivo?.vasDolor;
          const diffPct = r.objetivo?.volResultados?.diffPct;

          return (
            <PC key={r.id} style={{ borderLeft: `4px solid ${isl?.c || P.ac}`, marginBottom: 12 }}>
              {/* Encabezado */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8, marginBottom: 10 }}>
                <div>
                  <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: P.ac, fontWeight: 700 }}>
                    #{records.length - i}
                  </span>
                  <span style={{ color: P.txM, fontSize: 12, marginLeft: 10 }}>{fecha}</span>
                </div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {isl && <Bdg t={`${isl.s} · ${isl.n}`} c={isl.c} />}
                  {vas != null && (
                    <Bdg
                      t={`Dolor: ${vas}/10 (${VAS_LABEL(vas)})`}
                      c={VAS_COLOR(vas)}
                    />
                  )}
                  {diffPct != null && (
                    <Bdg
                      t={`Dif. vol: ${diffPct > 0 ? "+" : ""}${diffPct.toFixed(1)}%`}
                      c={diffPct >= 20 ? "#dc2626" : diffPct >= 10 ? "#ca8a04" : "#16a34a"}
                    />
                  )}
                </div>
              </div>

              {/* Plan de tratamiento (único campo clínico visible para el paciente) */}
              {r.plan && (
                <div style={{ background: "#f9f7f4", borderRadius: 8, padding: "10px 14px" }}>
                  <p style={{ margin: "0 0 4px", fontSize: 11, color: P.txM, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                    Plan de tratamiento
                  </p>
                  <p style={{ margin: 0, color: P.tx, fontSize: 13, lineHeight: 1.6 }}>{r.plan}</p>
                </div>
              )}
            </PC>
          );
        })
      )}
    </div>
  );
}
